module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.status == 'selection') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select Sales order number",
      "label": "sales_order_number",
      "options": _vm.sales_orders,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.sales_order),
      callback: function($$v) {
        _vm.sales_order = $$v
      },
      expression: "sales_order"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Pick a range"
    },
    model: {
      value: (_vm.unformat_etd_date_range),
      callback: function($$v) {
        _vm.unformat_etd_date_range = $$v
      },
      expression: "unformat_etd_date_range"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Vendors",
      "label": "name",
      "track-by": "name",
      "options": _vm.vendors,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.vendor_filters),
      callback: function($$v) {
        _vm.vendor_filters = $$v
      },
      expression: "vendor_filters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Manufacturers",
      "label": "name",
      "track-by": "name",
      "options": _vm.item_manufacturers,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.item_manufacturer_filters),
      callback: function($$v) {
        _vm.item_manufacturer_filters = $$v
      },
      expression: "item_manufacturer_filters"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Shipping Method",
      "label": "name",
      "track-by": "id",
      "options": _vm.shipping_methods,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.shipping_method),
      callback: function($$v) {
        _vm.shipping_method = $$v
      },
      expression: "shipping_method"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control pull-left",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Part Number"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        _vm.getSalesOrderItems(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v("  \n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Delivery Code",
      "label": "code",
      "track-by": "id",
      "options": _vm.delivery_codes,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.delivery_code),
      callback: function($$v) {
        _vm.delivery_code = $$v
      },
      expression: "delivery_code"
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.sales_order_items_all),
      expression: "sales_order_items_all",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sales_order_items,
      "border": "",
      "row-class-name": _vm.statusClass
    },
    on: {
      "sort-change": _vm.sortTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Sales Order No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sales_order.client_delivery_address.code",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Delivery Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.manufacturer",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Manufacturer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Vendor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "show-overflow-tooltip": true,
      "label": "Part Number",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETD Vendor",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-vendor",
      "width": "200",
      "sortable": 'custom',
      "prop": "estimated_td_vendor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETA HK",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-hk",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n\t\t                                    " + _vm._s(scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != '' ? scope.row.estimated_arrival_date_hk : 'Waiting for PO') + "\n\t\t                                ")]) : _c('span', [_vm._v("\n\t\t                                \tDirect Shipment\n\t\t                                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-td-hk',
      "width": "200",
      "label": "Confirmed TD HK",
      "sortable": 'custom',
      "prop": "estimated_td_date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.direct_shipment) ? _c('div', [_vm._v("Direct Shipment")]) : _c('div', [(!scope.row.estimated_td_date) ? _c('div', [(!scope.row.direct_shipment) ? _c('span', [_vm._v("Pending")]) : _vm._e()]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_date))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shipping_method.name",
      "show-overflow-tooltip": true,
      "width": "200",
      "label": "Shipping Method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-weight',
      "width": "200",
      "label": "Estimated weight, kg"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")((scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)), '', 2, {
          thousandsSeparator: ','
        })))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-primary btn-xtra-small",
          attrs: {
            "disabled": _vm.isAdded(scope.row)
          },
          on: {
            "click": function($event) {
              _vm.addItem(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "total": _vm.pagination.total,
      "layout": "total, prev, pager, next, sizes",
      "current-page": _vm.pagination.current_page,
      "page-size": _vm.limit,
      "page-sizes": [5, 10, 15, 20, 25, 30, 50]
    },
    on: {
      "current-change": _vm.fetchPaginate,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" Selected Items "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.items,
      "border": "",
      "row-class-name": _vm.statusClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Sales Order No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sales_order.client_delivery_address.code",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Delivery Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.manufacturer",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Manufacturer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Vendor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "show-overflow-tooltip": true,
      "label": "Part Number",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETD Vendor",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-vendor",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETA HK",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-hk",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n\t\t                                    " + _vm._s(scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != '' ? scope.row.estimated_arrival_date_hk : 'Waiting for PO') + "\n\t\t                                ")]) : _c('span', [_vm._v("\n\t\t                                \tDirect Shipment\n\t\t                                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-td-hk',
      "width": "200",
      "label": "Confirmed TD HK"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.estimated_td_date) ? _c('div', [(!scope.row.direct_shipment) ? _c('span', [_vm._v("Pending")]) : _vm._e()]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_date))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shipping_method.name",
      "show-overflow-tooltip": true,
      "width": "200",
      "label": "Shipping Method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-weight',
      "width": "200",
      "label": "Estimated weight, kg"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")((scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)), '', 2, {
          thousandsSeparator: ','
        })))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-xtra-small",
          on: {
            "click": function($event) {
              _vm.removeItem(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-remove"
        })])]
      }
    }])
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.items.length
    },
    on: {
      "click": function($event) {
        _vm.status = 'contact-sharing'
      }
    }
  }, [_vm._v("Next")])])])]) : _vm._e(), _vm._v(" "), (_vm.status == 'contact-sharing') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v(_vm._s(_vm.responsible_person.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select Person",
      "label": "name",
      "options": _vm.contact_options,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.email_person),
      callback: function($$v) {
        _vm.email_person = $$v
      },
      expression: "email_person"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.addContact()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.contacts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "show-overflow-tooltip": true,
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "show-overflow-tooltip": true,
      "label": "E-mail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "140",
      "class-name": "text-center",
      "label": "Operations"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "btn btn-danger btn-xtra-small",
          on: {
            "click": function($event) {
              _vm.removeContact(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.status = 'selection'
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('b', [_vm._v("Step 1-4:selection")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sales Order Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("ETD Vendor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Shipping Method")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "col-form-label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Delivery Code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('b', [_vm._v("Step 2-4:Contact Sharing")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Responsible person:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("List of persons to share notifications:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241215b3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup-forms/hq-delivery-date-change.vue
// module id = 271
// module chunks = 91